@use "stylesheets/utility/variables";

.link {
  display: inline;
  color: var(--text-interactive);
  text-decoration: underline;
  align-items: center;
  transition: background-color 0.2s ease;
  cursor: pointer;
  font-weight: 500;
  &:hover {
    text-decoration: none;
  }
  &:focus {
    outline-color: var(--accent-teal);
  }
  &:active {
    color: var(--text-interactive);
  }
  &:visited {
    color: var(--brand-primary-green);
  }
  > svg {
    vertical-align: middle;
  }
  > span {
    vertical-align: text-bottom;
  }
}
